import { ResponsiveContainer, AreaChart, Area, XAxis, YAxis, Tooltip, CartesianGrid } from "recharts";

const data = [
  { m: "Jan", up: 99.2 },
  { m: "Feb", up: 99.4 },
  { m: "Mar", up: 99.5 },
  { m: "Apr", up: 99.6 },
  { m: "May", up: 99.7 },
  { m: "Jun", up: 99.8 },
  { m: "Jul", up: 99.85 },
  { m: "Aug", up: 99.9 },
];

export default function NetworkChart() {
  return (
    <section className="py-10">
      <div className="container-max">
        <div className="card p-6">
          <div className="flex items-end justify-between gap-4 flex-wrap">
            <div>
              <h3 className="text-xl font-extrabold">Network Uptime</h3>
              <p className="text-sm text-brand-blue/70">Consistently high reliability over recent months</p>
            </div>
            <div className="text-2xl font-bold text-green-600">99.9%</div>
          </div>
          <div className="h-56 mt-4">
            <ResponsiveContainer width="100%" height="100%">
              <AreaChart data={data} margin={{ left: 0, right: 0, top: 10, bottom: 0 }}>
                <defs>
                  <linearGradient id="uptime" x1="0" y1="0" x2="0" y2="1">
                    <stop offset="5%" stopColor="#FF8C00" stopOpacity={0.35}/>
                    <stop offset="95%" stopColor="#FF8C00" stopOpacity={0.02}/>
                  </linearGradient>
                </defs>
                <CartesianGrid strokeDasharray="3 3" stroke="#e9eef6" />
                <XAxis dataKey="m" stroke="#98a2b3" tickLine={false} axisLine={false} />
                <YAxis domain={[99, 100]} stroke="#98a2b3" tickLine={false} axisLine={false} tickFormatter={(v) => `${v}%`} />
                <Tooltip formatter={(v) => `${v}%`} cursor={{ stroke: '#cbd5e1' }} />
                <Area type="monotone" dataKey="up" stroke="#FF8C00" fillOpacity={1} fill="url(#uptime)" />
              </AreaChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>
    </section>
  );
}

